import { camelCase } from 'lodash';

export const validateVal = ({
	value,
	required,
	maxLength,
	minLength,
	type,
	minValue,
	maxValue,
}) => {
	let retVal = '';
	if (required && !!value === false) retVal += 'Input Required ';
	if (value) {
		if (value.length > maxLength)
			retVal += `Input is Too Long Maximum ${maxLength} Characters `;
		if (value.length < minLength)
			retVal += `Input is Too Short Minimum ${minLength} Characters `;
		if (type === 'email') {
			const pattern = new RegExp(
				/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
			);

			if (!pattern.test(value)) {
				retVal += 'Please enter valid email address ';
			}
		}
		if (type === 'phoneNumber') {
			const pattern = new RegExp(/^[0-9\b]+$/);
			if (
				value !== '' &&
				(!pattern.test(value) || value.length < 10 || value.length > 11)
			) {
				retVal += 'Please enter valid Phone Number ';
			}
		}
		if (type === 'year') {
			const pattern = new RegExp(/^[0-9\b]+$/);
			if (
				value !== '' &&
				(!pattern.test(value) || String(value).length !== 4)
			) {
				retVal += 'Please enter valid Year ';
			}
		}
		if (type === 'money') {
			const pattern = new RegExp(
				/^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/
			);
			if (value !== '' && !pattern.test(value)) {
				retVal += 'Please enter currency format ';
			}
		}
		if (value < minValue) {
			retVal += `Value be higher that ${minValue}`;
		}
		if (value > maxValue) {
			retVal += `Value be lower that ${maxValue}`;
		}
	}

	return retVal;
};

export const isEmpty = (object) => {
	return object
		? Object.values(object).every((x) => x === null || x === '')
		: !object;
};

export const joinRelatedRowData = (inputTableData, relation, relatedTable) => {
	const baseTable = inputTableData.length ? inputTableData : [inputTableData];
	return baseTable.map((row) => {
		const blank = {};
		relation.columns.map((col) => {
			blank[camelCase(`${relation.table}_${col}`)] = relatedTable.find(
				(foreignItem) => foreignItem.id === row[relation.foreignKey]
			)[col];
			return blank;
		});
		return {
			...blank,
			...row,
		};
	});
};

export const formatDate = (dateString, raw = false) => {
	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	const date = new Date(dateString);

	if (raw) {
		return date;
	} else {
		return `${
			months[date.getMonth()]
		} ${date.getDate()}, ${date.getFullYear()}`;
	}
};

export const convertYearToISO = (year) =>
	year ? new Date(year, 1, 1).toISOString() : null;

export const formatDateNumbers = (date) => {
	let d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return [year, month, day].join('-');
};

export const getDateNow = () =>{

	let d = new Date(),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();

    
	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;

	return month + '/' + day + '/' + year


}

export const Extrim = (p_string) => {

    if(p_string){
        let t = p_string.trim();
        t = t.replace(/(\r\n|\n|\r)/gm, '');
        t = t.replace(/[^0-9a-zA-Z.]/g, '')
        return t;
    }else{
        return '';
    }

}

export const IsValidMail = (p_mail) => {
    if(p_mail){
        let mail = p_mail.trim();
        return /^[a-z0-9][a-z0-9-_\.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(mail);
    }
}


export const genKey = () => {
	var d = new Date();
	var n =  d.getTime();

	let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

	let str = '';
	for (let i = 0; i < 4; i++) {
		str += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	str = str + n.toString();
	return str;
}

export default Extrim
